import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "../Components/Button";
import InputBoxDisableTrans from "../Components/InputBoxDisableTrans";
import { ReactComponent as IconInfoRed } from "../Images/icon_info_red.svg";
import Footer from "../Layout/Footer";
import "../Styles/global.css";
import { useGoToAddr } from "../Utils/navigationUtils.js";
import { showToast } from "../Utils/variables.js";

const EmailAuthSent = () => {
  const location = useLocation();
  const [input_certNumber, setInput_certNumber] = useState("");
  const [error_message, setError_message] = useState("");
  const [hasError, setHasError] = useState(false);

  const goToAddr = useGoToAddr();
  const navigate = useNavigate();

  const email_address = location.state?.email_address;

  const calculateTimeRemaining = () => {
    const sentTime = localStorage.getItem("sentTime");
    const currentTime = Math.floor(Date.now() / 1000);
    return Math.max(180 - (currentTime - sentTime), 0);
  };
  const [timeRemaining, setTimeRemaining] = useState(calculateTimeRemaining);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  const handleInput_certNumber = (value) => {
    setInput_certNumber(value);
  };

  const handleAuth = () => {
    if (timeRemaining > 0) {
      if (location.state?.cert_num === input_certNumber) {
        navigate("/updatepw", { state: { certified: true } });
      } else {
        setError_message("인증번호 오류. 다시 한 번 입력해주세요.");
        setHasError(true);
      }
    } else {
      setHasError(true);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeRemaining(calculateTimeRemaining());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (location.state?.toast_enable) {
      showToast(location.state.toast_message, location.state.toast_type);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className="page-wrapper center">
      <AuthBox>
        <h1>이메일 인증</h1>
        <p style={{ marginTop: 10 }}>아래 이메일로 인증 번호를 발송했습니다.</p>
        <p>다른 이메일로 발송하려면 이전 페이지로 돌아가주세요.</p>
        <p style={{ marginTop: 30, fontSize: "14px" }}>기업 이메일</p>
        <p className="emailaddress">{email_address}</p>
        <div style={{ marginTop: 14 }}>
          <InputBoxDisableTrans
            message="인증번호 입력"
            handleInput={handleInput_certNumber}
            hasError={hasError}
            setError_message={(value) => setError_message(value)}
            type="certNumber"
          />
        </div>

        {error_message && (
          <div className="errormessage" style={{ display: "flex" }}>
            <IconInfoRed />
            <p
              style={{
                color: "#f25c5c",
                fontSize: "14px",
                marginLeft: "4px",
                marginTop: "2px",
              }}
            >
              {error_message}
            </p>
          </div>
        )}

        {timeRemaining === 0 ? (
          <p className="errormessage">
            인증시간이 만료되었습니다. 다시 한 번 시도해주세요.
          </p>
        ) : (
          <p className="exptime">유효 시간 {formatTime(timeRemaining)}</p>
        )}
        <div onClick={handleAuth} style={{ marginTop: 40 }}>
          <Button message="인증" />
        </div>
        <p className="checkmessage">혹시 메일이 아직 오지 않았나요?</p>
        <button onClick={() => goToAddr("emailauth")}>이메일 다시 받기</button>
      </AuthBox>
      <Footer />
    </div>
  );
};

const AuthBox = styled.div`
  width: 400px;
  height: auto;
  margin-top: 240px;
  margin-bottom: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "notoSans";
  > h1 {
    margin: 0;
    font-size: 30px;
    font-weight: bold;
  }
  > p {
    font-size: 16px;
    color: #888888;
    margin: 0;
  }
  > button {
    width: 295px;
    height: 51px;
    border-radius: 10px;
    border: 1px solid #e4e4e4;
    background-color: #ffffff;
    font-family: "notoSans-medium";
    color: #222222;
    font-size: 16px;
    margin-top: 10px;
    cursor: pointer;
  }
  > button:hover {
    background-color: #e4e4e4;
    border: 1px solid #b0b0b0;
    color: #888888;
  }
  .emailaddress {
    color: #555555;
    font-family: "notoSans-medium";
    margin-top: 4px;
  }
  .exptime {
    color: #1167ed;
    font-family: "notoSans-medium";
    font-size: 14px;
    margin-top: 6px;
    margin-right: auto;
  }
  .checkmessage {
    color: #222222;
    margin-top: 40px;
  }

  .errormessage {
    margin-top: 6px;
    color: #f25c5c;
    font-size: 14px;
    font-family: "notoSans-medium";
    align-self: baseline;
  }
`;

export default EmailAuthSent;
